<template>
  <div class="button-add-insumo">
        <b-button :class="`${this.escritoBotao ? 'button-adicionar' : 'button-animation'}`" @click="buttonAnimation" >
            <div v-if="escritoBotao">Adicionar</div>
            <div v-if="!escritoBotao"><i class="fas fa-check icone-check"></i></div>
        </b-button>
    </div>
</template>

<script>
export default {
  props: ['id'],
  name: 'inputbutton',
  data () {
    return {
      escritoBotao: true
    }
  },
  methods: {
    buttonAnimation () {
      this.escritoBotao = !this.escritoBotao
    }
  }

}
</script>

<style scoped>
.button-adicionar{
    /* margin-top: 0.3rem;
    height: 30px;
    width: 80px; */
    transition: all .3s ease-in-out;
    background-color: #008148;

}
.button-add-insumo{
    display: flex;
    justify-content: end;
    width: 100%;
}
.button-adicionar:after {
            transform: (40%);
            width: 20px;
            /* Scaling button to 0.98 to its original size */
            box-shadow: 3px 2px 22px 1px rgba(240, 105, 105, 0.24);
            /* Lowering the shadow */
        }
.button-animation{
    display: flex;
    justify-content: center;
    height: 30px;
    width: 30px;
    transition: all .3s ease-in-out;
    align-items: center;
    background-color: #008148;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/InputCosts/components/inputbutton.vue